import { ExamFormFields } from '@/components/exam/ExamForm';
import Exam, { ExamTypeEnum } from '@/models/Exam';

export const examToFields = (exam?: Exam): ExamFormFields => ({
  name: exam?.name ?? '',
  description: exam?.description ?? '',
  type: exam?.type ?? ExamTypeEnum.TEST,
  defaultTime: exam?.defaultTime ?? 90,
  assessmentId: exam?.assessmentItem?.assessmentId ?? null,
  assessmentItemId: exam?.assessmentItem?.id ?? null,
});
